import { render, staticRenderFns } from "./CopyArticlesDialog.vue?vue&type=template&id=0edf9318"
import script from "./CopyArticlesDialog.vue?vue&type=script&lang=ts"
export * from "./CopyArticlesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports